<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <v-row justift-left>
        <v-col cols="auto">
          <div class="display-1 text-center mb-n2">LDBC</div>
          <span class="caption font-weight-thin">lockdown boot camp</span>
        </v-col>
        <v-col cols="auto">
          <v-btn icon left :to="{name: 'Home'}"><v-icon>mdi-home</v-icon></v-btn>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto">
          <v-btn icon right :loading="loading" @click="refresh"><v-icon>mdi-refresh</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-app-bar>

    <v-content>
      <p class="text-center pt-3 font-italic body-2">A group of friends working out together, independently.</p>
      <v-row justify="center">
        <v-col cols="auto">
          <router-view></router-view>
        </v-col>
      </v-row>
      <router-view name="extras"></router-view>
    </v-content>
  </v-app>
</template>

<script>
import Vue from "vue";
import {mapState} from 'vuex';
// import BootcampMeeting from "@/views/BootcampMeeting.vue";

import db from '@/db.ts'
import moment from 'moment-timezone'

export default Vue.extend({
  name: "App",

  components: {
      // BootcampMeeting,
  },
  computed: {
    ...mapState('checkout', {
      active: 'activeCheckouts'
    }),
    ...mapState('workout', {
      workouts: 'active'
    }),
    loadingCO() {
      return this.$store.state.checkout.loadingCheckouts
    },
      loading() {
          return !!this.loadingPromise
      }
  },
  data: () => ({
      loadingPromise: null,
      events: []
  }),
  methods: {
    refresh() {
      // console.log("MOUNT")
      this.$store.commit('refresh')
    }
  }
});
</script>
